var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foreground-container"},[_c('div',{staticClass:"container"},[_c('el-tree',{attrs:{"data":_vm.tree,"props":_vm.defaultProps},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var _obj, _obj$1;

var data = ref.data;return [_c('i',{staticClass:"el-icon-user-solid"},[_c('span',{class:[
              _vm.$style.accountBlock,
              ( _obj = {}, _obj[_vm.$style.textDecoration] = data.child_is_alive === null, _obj ) ]},[_vm._v("\n            "+_vm._s(data.child_user_id)+"\n          ")]),(data.child_is_alive === null)?_c('span',{class:[
              _vm.$style.accountBlock,
              ( _obj$1 = {}, _obj$1[_vm.$style.color] = data.child_is_alive === null, _obj$1 ) ]},[_vm._v("\n            탈퇴한 회원입니다.\n          ")]):_vm._e()])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }